/** @format */

import config from 'config';
import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import CustomButton from 'components/CustomButton';
import ButtonSyncLoader from 'components/ButtonSyncLoader';
import ImageCard from 'views/Broker/Profile/BrokerProfile/ImageCard';
import ContactIcons from 'views/Broker/Profile/BrokerProfile/ContactIcons';
import BrokerServiceBox from './BrokerServiceBox';
import {
  faEdit,
  faFloppyDisk,
  faCircleXmark
} from '@fortawesome/free-solid-svg-icons';
import { AiOutlinePlusCircle } from 'react-icons/ai';
import FetchMore from 'views/Broker/Profile/BrokerProfile/FetchMore';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Formik, Form, Field, FieldArray } from 'formik';
import { updateBrokerAction } from 'stateContainer/actions';

export default function BrokerProfileContent(props) {
  const dispatch = useDispatch();
  const {
    target,
    brokerEmail,
    brokerPhone,
    showCopySuccess,
    onClickCopyProfile,
    copyProfileUrlSuccess,
    properties,
    firstName,
    lastName,
    profilePic,
    description,
    services,
    usps,
    tprop,
    region
  } = props;

  const {
    data: {
      userData: { brokerId }
    }
  } = useSelector((state) => state.session);
  const {
    isUpdating,
    data: { isEditable, searchable }
  } = useSelector((state) => state.brokerProfile);
  const { data } = useSelector((state) => state.brokerObjects);

  const [key, setKey] = React.useState('overview');
  const [updatedUSPs, setUpdatedUSPs] = React.useState(usps);
  const [isEditMode, setIsEditMode] = React.useState(false);
  const [servicesList, setServicesList] = React.useState(services);

  function generatePropertyUrl(propertyId) {
    return `${config.app.friaMaklareWebOriginUrl}/objekt?objectId=${propertyId}`;
  }

  const updateServiceList = (index, value) => {
    const list = JSON.parse(JSON.stringify(servicesList));
    let itemKey = Object.keys(servicesList[index])[0];
    list[index][itemKey] = value;
    setServicesList(list);
  };

  const handleSubmit = async (values) => {
    setIsEditMode(!isEditMode);

    let usps = updatedUSPs;
    // remove empty items
    const filteredUsps = values.filter((item) => item !== '');

    await setUpdatedUSPs(filteredUsps);

    usps = filteredUsps;

    // rearrange usps to suit api format
    const uspsRearranged = Object.values(usps).map((item) => {
      return item.name;
    });

    const data = {
      uspsList: usps,
      servicesList,
      brokerId,
      brokerUsp: uspsRearranged
    };
    // rearrange services to suit api format
    servicesList.forEach((element) => {
      data[Object.keys(element)[0]] = Object.values(element)[0];
    });

    !isUpdating && dispatch(updateBrokerAction(data));
  };

  /* ----------- Filter commented out ---------- */
  // const Filter = () => {
  //   return (
  //     <Formik initialValues={initialValues} onSubmit={onSubmit}>
  //       {() => (
  //         <Form className='form-group filter-objects-form'>
  //           <Row>
  //             <Col>
  //               <label>{tprop.filter.location.text}</label>
  //               <Field
  //                 as='select'
  //                 className='form-control text4r input-location'
  //                 type=''
  //                 name='location'
  //                 {...props}>
  //                 <option value='0'>Select here</option>
  //                 <option value='red'>Red</option>
  //                 <option value='green'>Green</option>
  //                 <option value='blue'>Blue</option>
  //               </Field>
  //             </Col>
  //             <Col>
  //               <label>{tprop.filter.propertyType.text}</label>
  //               <Field
  //                 as='select'
  //                 className='form-control input-property-type'
  //                 type=''
  //                 name='propertyType'
  //                 {...props}>
  //                 <option value='0'>Select here</option>
  //                 <option value='red'>Red</option>
  //                 <option value='green'>Green</option>
  //                 <option value='blue'>Blue</option>
  //               </Field>
  //             </Col>
  //             <Col>
  //               <label>{tprop.filter.price.text}</label>
  //               <Field
  //                 className='form-control input-min-price'
  //                 type=''
  //                 name='minPrice'
  //                 placeholder='Min'
  //                 {...props}
  //               />
  //             </Col>
  //             <div className='price-seperator'>-</div>
  //             <Col className='add-top-margin'>
  //               <Field
  //                 className='form-control input-max-price'
  //                 type=''
  //                 name='maxPrice'
  //                 placeholder='Max'
  //                 {...props}
  //               />
  //             </Col>
  //             <CustomButton
  //               className='add-top-margin button-filter'
  //               isBgPink
  //               text={tprop.filter.buttons.text}
  //             />
  //           </Row>
  //         </Form>
  //       )}
  //     </Formik>
  //   );
  // };

  const { banner } = props.t('lang_common:brokerProfile');
  const { dimensionsUnit } = props.t('lang_common:broker_profile');

  const hasZeroPropertiesListed = properties.length === 0;

  const hasLessThanSixPropertiesListed =
    properties.length > 0 && properties.length < 6;

  const showBanner = hasZeroPropertiesListed;

  const Banner = ({ text }) => {
    return (
      <div className='broker-properties-banner'>
        <div className='banner-banner-left icon-exclamation'></div>
        <div className='banner-banner-right'>{text}</div>
      </div>
    );
  };

  const ListOfObjectsContainer = () => {
    return (
      <>
        <div className='list-of-objects-container'>
          {/* <Filter /> */}
          <p className='broker-profile-subheading'>{tprop.subheading.text}</p>

          {!showBanner && properties !== undefined && (
            <Row xs={1} md={3} className='g-4 listing-container'>
              {properties.map(
                (
                  {
                    id,
                    type,
                    location,
                    noOfBathrooms,
                    noOfBedrooms,
                    price,
                    startingPrice,
                    finalPrice,
                    livingSpace,
                    status,
                    imageUrl
                  },
                  key
                ) => (
                  <Col key={key}>
                    <a href={generatePropertyUrl(id)} key={key}>
                      <ImageCard
                        type={type}
                        location={location}
                        price={price}
                        startingPrice={startingPrice}
                        finalPrice={finalPrice}
                        bedrooms={noOfBedrooms}
                        bathrooms={noOfBathrooms}
                        dimensions={livingSpace}
                        currency={props.t('lang_common:currency')}
                        status={status}
                        imageUrl={imageUrl}
                        dimensionsUnit={dimensionsUnit}
                        translation={props.t('lang_common:propertyType')}
                      />
                    </a>
                  </Col>
                )
              )}
            </Row>
          )}
          {data.length > 0 && <FetchMore {...props} />}

          {hasZeroPropertiesListed && !hasLessThanSixPropertiesListed && (
            <Banner text={banner.hasZeroPropertiesListed.text} />
          )}

          {hasLessThanSixPropertiesListed && !hasZeroPropertiesListed && (
            <Banner text={banner.hasLessThanSixPropertiesListed.text} />
          )}
        </div>
      </>
    );
  };

  const {
    descriptionTitle,
    myServicesTitle,
    uspTitle,
    addNewUSP: addNewUSPText,
    saveChanges: saveChangesText,
    editProfile: editProfileText,
    services: servicesText,
    verified,
    profileStatus
  } = props.t('lang_common:brokerProfile');

  function getServices(index) {
    switch (index) {
      case 0:
        if (servicesList[index].houseService) return true;

        break;

      case 1:
        if (servicesList[index].apartmentService) return true;
        break;

      case 2:
        if (servicesList[index].cottageService) return true;
        break;

      case 3:
        if (servicesList[index].plotService) return true;
        break;

      case 4:
        if (servicesList[index].farmService) return true;
        break;

      default:
        return false;
    }
  }

  const addNewUsp = ({ arrayHelpers, length }) => {
    if (length > 0) {
      const values = arrayHelpers.form.values;

      const hasEmptyItem = values.uspList.filter((item) => item == '').length;
      if (!hasEmptyItem) {
        arrayHelpers.unshift('');
      }
    } else {
      arrayHelpers.unshift('');
    }
  };

  const AddressContainer = () => {
    return (
      <div className='profile-address-container'>
        <div className='profile-address-icon icon-location'></div>
        <div className='profile-address-address text2r'>{region}</div>
      </div>
    );
  };

  const MyServices = (props = { mobileHidden: false }) => {
    return (
      <div
        className={`profile-my-services-container ${
          props.mobileHidden && 'mobile-hidden'
        }`}>
        <div className='text3m'>{myServicesTitle}</div>
        <div className='profile-my-services-row'>
          {servicesText.map(
            (service, index) =>
              getServices(index) && (
                <BrokerServiceBox
                  index={index}
                  service={service}
                  key={index}
                  isEditMode={isEditMode}
                  onClick={() => updateServiceList(index, false)}
                  servicesList={servicesList}
                  iconType={'remove'}
                />
              )
          )}
        </div>
        {isEditMode && (
          <>
            <div className='add-new-service-container'></div>

            <div className='profile-my-services-row'>
              {servicesText.map(
                (service, index) =>
                  !getServices(index) && (
                    <BrokerServiceBox
                      index={index}
                      service={service}
                      key={index}
                      isEditMode={isEditMode}
                      onClick={() => updateServiceList(index, true)}
                      servicesList={servicesList}
                      iconType={'add'}
                    />
                  )
              )}
            </div>
          </>
        )}
      </div>
    );
  };

  const ProfileUSP = (props) => {
    const addClassName = props.isMobile ? '-mobile' : '';
    return (
      <Col md={3} className={`profile-usp-container${addClassName}`}>
        {!isEditMode && (
          <div className='profile-usp-inner-container'>
            <div className='text3m'>{uspTitle}</div>
            <ul className='profile-usplist'>
              {updatedUSPs.map(({ name }, index) => (
                <React.Fragment key={index}>
                  <li className='text2r' key={index}>
                    {name}
                  </li>
                  {isEditMode && (
                    <FontAwesomeIcon icon={faCircleXmark} size='sm' />
                  )}
                </React.Fragment>
              ))}
            </ul>
          </div>
        )}
        {props.children}
      </Col>
    );
  };

  const ProfileDescription = () => {
    return (
      <Row className='profile-description-container'>
        <Col md={9} className='description-box'>
          <div className='text3m'>{descriptionTitle}</div>
          <p className='text2r'>{description}</p>
        </Col>
        <MyServices mobileHidden={true} />
      </Row>
    );
  };

  const overviewText = props.t(
    `lang_common:broker_profile.mobiletabs.overview.text`
  );
  const allPropertiesText = props.t(
    `lang_common:broker_profile.mobiletabs.allproperties.text`
  );

  const profileStatusText = searchable
    ? profileStatus.public.text
    : profileStatus.private.text;

  return (
    <>
      <>
        <div className='profile-status'>{profileStatusText}</div>
        <Formik
          initialValues={{ uspList: updatedUSPs }}
          onSubmit={(values) => handleSubmit(values.uspList)}>
          {({ values }) => (
            <Form>
              <div className='profile-container'>
                <div className='profile-container-left'>
                  <img className='image-profile-foreground' src={profilePic} />

                  <div className='contact-icon-container-desktop'>
                    <ContactIcons
                      brokerPhone={brokerPhone}
                      brokerEmail={brokerEmail}
                      target={target}
                      onClickCopyProfile={onClickCopyProfile}
                      showCopySuccess={showCopySuccess}
                      copyProfileUrlSuccess={copyProfileUrlSuccess}
                    />
                  </div>
                </div>

                <img
                  className='image-profile-foreground-mobile'
                  src={profilePic}
                />
                <div className='profile-container-right'>
                  <div className='profile-heading-container'>
                    <h2 className='profile-heading-heading'>
                      {firstName + ' ' + lastName}
                    </h2>

                    <AddressContainer />
                    <div className='profile-edit-container'>
                      <p className='profile-verified-container'>
                        <img src='../images/image-tick-green.svg' />
                        {verified}
                      </p>
                      <div className='profile-status mobile-status'>
                        {profileStatusText}
                      </div>
                      {!isEditMode && isUpdating && (
                        <CustomButton>
                          <ButtonSyncLoader />
                        </CustomButton>
                      )}
                      {!isEditMode && !isUpdating && isEditable && (
                        <CustomButton
                          onClick={() => setIsEditMode(!isEditMode)}>
                          <FontAwesomeIcon icon={faEdit} size='lg' />
                          {editProfileText.text}
                        </CustomButton>
                      )}
                      {isEditMode && isEditable && (
                        <CustomButton type='submit'>
                          <FontAwesomeIcon icon={faFloppyDisk} size='lg' />
                          {saveChangesText.text}
                        </CustomButton>
                      )}
                    </div>
                  </div>
                  <AddressContainer />
                  <div className='contact-icon-container-mobile'>
                    <ContactIcons
                      brokerPhone={brokerPhone}
                      brokerEmail={brokerEmail}
                      target={target}
                      onClickCopyProfile={onClickCopyProfile}
                      showCopySuccess={showCopySuccess}
                      copyProfileUrlSuccess={copyProfileUrlSuccess}
                    />
                  </div>
                  <div className='profile-description-and-usp-box'>
                    <ProfileDescription />
                    <ProfileUSP isMobile={false}>
                      {isEditMode && (
                        <FieldArray
                          name='uspList'
                          maxLength={30}
                          render={(arrayHelpers) => (
                            <div>
                              {values.uspList && values.uspList.length > 0 ? (
                                <>
                                  {values.uspList.map((item, index) => (
                                    <div key={index}>
                                      <React.Fragment key={index}>
                                        <li
                                          className='text2r edit-usp-item '
                                          key={index}>
                                          <Field
                                            name={`uspList.${index}.name`}
                                            maxLength='30'
                                          />
                                          <FontAwesomeIcon
                                            icon={faCircleXmark}
                                            size='sm'
                                            type='button'
                                            onClick={() =>
                                              arrayHelpers.remove(index)
                                            }
                                          />
                                        </li>
                                      </React.Fragment>

                                      {index === values.uspList.length - 1 &&
                                        values.uspList.length < 10 && (
                                          <div
                                            className='add-new-usp-container'
                                            onClick={() =>
                                              addNewUsp({
                                                index,
                                                arrayHelpers,
                                                length: values.uspList.length
                                              })
                                            }>
                                            <AiOutlinePlusCircle className='add-new-icon' />
                                            {addNewUSPText.text}
                                          </div>
                                        )}
                                    </div>
                                  ))}
                                </>
                              ) : (
                                <div
                                  className='add-new-usp-container'
                                  onClick={() =>
                                    addNewUsp({
                                      arrayHelpers,
                                      length: values.uspList.length
                                    })
                                  }>
                                  <AiOutlinePlusCircle className='add-new-icon' />
                                  {addNewUSPText.text}
                                </div>
                              )}
                            </div>
                          )}
                        />
                      )}
                    </ProfileUSP>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </>
      <div className='mobile-tabs'>
        <Tabs activeKey={key} onSelect={(k) => setKey(k)} className='mb-3'>
          <Tab eventKey='overview' title={overviewText}>
            <ProfileDescription />
            <ProfileUSP isMobile={true} />
            <MyServices />
          </Tab>
          <Tab eventKey='allProperties' title={allPropertiesText}>
            <ListOfObjectsContainer arraylength={3} />
          </Tab>
        </Tabs>
      </div>
      {/** tabs that were temporarily removed from design are below */}
      {/* <Tabs activeKey={key} onSelect={(k) => setKey(k)} className='mb-3'>
        <Tab eventKey='activeObjects' title='Active Objects'>
          <ListOfObjectsContainer arraylength={8} />
        </Tab>
        <Tab eventKey='completedSales' title='Completed Sales'>
          <ListOfObjectsContainer arraylength={3} />
        </Tab>
      </Tabs> */}
      <ListOfObjectsContainer />
    </>
  );
}
